<script setup lang="ts">
import { markRaw, onBeforeUnmount, watch } from "vue";
import { useAuth, useTelephony } from "../../../store";
import { pusher } from "../../../plugins/thirdparties/pusher";
import { useSnackbar } from "../../../composables/snackbar";
import { SnackbarType } from "../../../composables/snackbar/interfaces";
import TelephonyNotification from "../TelephonyNotification";
import { Call } from "./types";

//// LOCAL VARS
const broadcastChannels = [];
const activeCalls = [];

watch(
  () => useTelephony().loggedInStaffIsConfigured,
  (loggedInStaffIsConfigured) => {
    const auth = useAuth();

    if (auth.isLoggedIn && loggedInStaffIsConfigured) {
      const channelName = auth.config?.tenantId + "-telephony-" + auth.config?.staff.id;
      let channel = pusher.subscribe(channelName);

      channel.bind("inbound_call_initiated", (call: Call) => {
        const index = activeCalls.indexOf(call.id);
        if (index === -1) {
          activeCalls.push(call.id);
          useSnackbar().add({
            id: call.id,
            title: "Inbound Call",
            component: markRaw(TelephonyNotification),
            componentProps: {
              patients: call.patients,
              callId: call.id,
            },
            type: SnackbarType.Telephony,
            indefinite: true,
            persistent: false,
          });
        }
      });

      channel.bind("inbound_call_ended", (call: Call) => {
        const index = activeCalls.indexOf(call.id);
        if (index > -1) {
          activeCalls.splice(index, 1);
        }
        useSnackbar().remove(call.id);
      });

      broadcastChannels.push(channel);
    }
  },
);

onBeforeUnmount(() => {
  if (broadcastChannels.length === 0) {
    return;
  }

  broadcastChannels.forEach((x) => {
    x.unbind_all();
    x.unsubscribe();
  });
});
</script>
<template><div /></template>

<style scoped lang="scss"></style>
